import { STHead } from "@/components";
import { STHome } from "@/components/STHome";
import { getPageContentBySlug } from "@/actions";

export async function getStaticProps() {
  let pageData = null;
  try {
    const res = await getPageContentBySlug("home");
    if (res?.success && res?.data) {
      pageData = res.data;
    }
  } catch (error) {
    console.error("Error fetching home page data:", error);
  }

  return {
    props: {
      pageData,
    },
    revalidate: 60,
  };
}

export default function Home({ pageData }) {
  const pageContent = pageData?.page?.page_content || {};
  const imageUrlBase = pageData?.imageUrl || "https://sustanix.com/";

  const metaTitle = pageContent.meta_title || "Inventors of advanced biomaterials";
  const metaDescription =
    pageContent.meta_description ||
    "Inventors of advanced biomaterials to replace fossil-based materials as a drop-in technology without any green premium or capital overheads.";
  const metaKeywords =
    pageContent.meta_keywords ||
    "Biomaterials, Advanced biomaterials, barrier coatings, PPWR-compliant barrier coatings, Recyclable packaging, CEPI-Part 1 compliant packaging, Rotogravure coatings, solid-state coatings, coatings for flexible packaging, circular paper packaging, biomass to biocoatings, EPR ready packaging, PPWR regulated packaging";

  const ogTitle = pageContent.og_title || metaTitle;
  const ogDescription =
    pageContent.og_description ||
    "Sustanix develops novel biomolecules for advanced biomaterials, takes it from lab to industrial scale";
  const ogKeywords = pageContent.og_keywords || metaKeywords;

  const getOgImage = () => {
    if (pageContent.og_image_url) return pageContent.og_image_url;
    if (pageContent.og_image) {
      if (
        pageContent.og_image.startsWith("http://") ||
        pageContent.og_image.startsWith("https://") ||
        pageContent.og_image.startsWith("/")
      ) {
        return pageContent.og_image;
      }
      return imageUrlBase.endsWith("/")
        ? `${imageUrlBase}${pageContent.og_image}`
        : `${imageUrlBase}/${pageContent.og_image}`;
    }
    return "https://sustanix.com/opengraph-image.webp";
  };

  const ogImage = getOgImage();

  return (
    <>
      <STHead
        title={metaTitle}
        description={metaDescription}
        keywords={metaKeywords}
        canonicalUrl="https://sustanix.com"
        url="https://sustanix.com"
        ogTitle={ogTitle}
        ogDescription={ogDescription}
        ogKeywords={ogKeywords}
        ogUrl="https://sustanix.com"
        ogImage={ogImage}
        ogType="website"
      />
      <STHome pageData={pageData} />
    </>
  );
}

